import { Button } from '@lms/ui/button';
import { useToast } from '@lms/ui/use-toast';
import { useState } from 'react';
import { useTranslations } from 'use-intl';
import { removeCourseFromCurriculum } from '@/features/curriculums/curriculums-api';

// Ports app/[brand]/admin/curriculums/_components/remove-course-button.tsx.
// The caller revalidates via SWR `onRemoved`; failures surface as a toast.
export function RemoveCourseButton({
  curriculumId,
  courseId,
  className,
  onRemoved,
}: {
  curriculumId: number;
  courseId: number;
  className?: string;
  onRemoved: () => void;
}) {
  const t = useTranslations('admin');
  const { toast } = useToast();
  const [pending, setPending] = useState(false);

  const handleClick = async () => {
    setPending(true);
    try {
      const result = await removeCourseFromCurriculum(curriculumId, courseId);
      if (result.ok) {
        onRemoved();
      } else {
        toast({ variant: 'destructive', description: result.error });
      }
    } finally {
      setPending(false);
    }
  };

  return (
    <Button
      variant="destructive"
      className={className}
      disabled={pending}
      onClick={handleClick}
    >
      {t('remove', { what: t('course').toLowerCase() })}
    </Button>
  );
}
